import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import type { PoolFilters } from '../types/Checks';

export function usePoolAllocations(filters: PoolFilters) {
  return useQuery(allocationQueries.pool(filters));
}
